import { Component } from "@angular/core";

@Component({
  selector: 'th[app-dt-head-th]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['dt-head-th.component.scss'],
})
export class DtHeadThComponent {}
